export default "__VITE_ASSET__DpIXnfFY__"